import React, { useState } from 'react';
import { Palette as PaletteIcon, Users as UsersIcon, Shield as ShieldIcon, Bell as BellIcon, Globe as GlobeIcon, Save as SaveIcon, Upload as UploadIcon } from 'lucide-react';
import { Tenant } from '../../types';
interface SettingsPageProps {
  tenant: Tenant;
}
export function SettingsPage({
  tenant
}: SettingsPageProps) {
  const [activeSection, setActiveSection] = useState('branding');
  const sections = [{
    id: 'branding',
    label: 'Branding',
    icon: PaletteIcon
  }, {
    id: 'general',
    label: 'Allgemein',
    icon: GlobeIcon
  }, {
    id: 'members',
    label: 'Mitglieder',
    icon: UsersIcon
  }, {
    id: 'notifications',
    label: 'Benachrichtigungen',
    icon: BellIcon
  }, {
    id: 'security',
    label: 'Sicherheit',
    icon: ShieldIcon
  }];
  return <div className="grid grid-cols-1 lg:grid-cols-4 gap-6" data-id="element-771">
      {/* Settings Nav */}
      <div className="lg:col-span-1" data-id="element-772">
        <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden" data-id="element-773">
          <div className="p-4 border-b border-slate-100" data-id="element-774">
            <h3 className="font-bold text-slate-900" data-id="element-775">Einstellungen</h3>
          </div>
          <nav className="p-2" data-id="element-776">
            {sections.map(section => <button key={section.id} onClick={() => setActiveSection(section.id)} className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${activeSection === section.id ? 'bg-emerald-50 text-emerald-700' : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900'}`} data-id="element-777">
                <section.icon size={18} className={activeSection === section.id ? 'text-emerald-500' : 'text-slate-400'} data-id="element-778" />
                {section.label}
              </button>)}
          </nav>
        </div>
      </div>

      {/* Settings Content */}
      <div className="lg:col-span-3 space-y-6" data-id="element-779">
        {activeSection === 'branding' && <>
            <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-6" data-id="element-780">
              <h2 className="text-lg font-bold text-slate-900 mb-1" data-id="element-781">
                Club Branding
              </h2>
              <p className="text-sm text-slate-500 mb-6" data-id="element-782">
                Passen Sie das Erscheinungsbild Ihres Netzwerks an.
              </p>

              {/* Logo */}
              <div className="mb-8" data-id="element-783">
                <label className="block text-sm font-medium text-slate-700 mb-3" data-id="element-784">
                  Club Logo
                </label>
                <div className="flex items-center gap-6" data-id="element-785">
                  <div className="w-20 h-20 rounded-full flex items-center justify-center text-4xl shadow-md border-4 border-white" style={{
                backgroundColor: tenant.primaryColor
              }} data-id="element-786">
                    {tenant.logo}
                  </div>
                  <button className="flex items-center gap-2 px-4 py-2 bg-white border border-slate-200 rounded-lg text-sm font-medium text-slate-700 hover:bg-slate-50 transition-colors" data-id="element-787">
                    <UploadIcon size={16} data-id="element-788" />
                    Logo ändern
                  </button>
                </div>
              </div>

              {/* Colors */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-8" data-id="element-789">
                <div data-id="element-790">
                  <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-791">
                    Primärfarbe
                  </label>
                  <div className="flex items-center gap-3" data-id="element-792">
                    <div className="w-10 h-10 rounded-lg border border-slate-200 shadow-inner cursor-pointer" style={{
                  backgroundColor: tenant.primaryColor
                }} data-id="element-793"></div>
                    <input type="text" defaultValue={tenant.primaryColor} className="flex-1 px-3 py-2 bg-slate-50 border border-slate-200 rounded-lg text-sm font-mono focus:border-emerald-500 focus:ring-1 focus:ring-emerald-500 outline-none" data-id="element-794" />
                  </div>
                </div>
                <div data-id="element-795">
                  <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-796">
                    Sekundärfarbe
                  </label>
                  <div className="flex items-center gap-3" data-id="element-797">
                    <div className="w-10 h-10 rounded-lg border border-slate-200 shadow-inner cursor-pointer" style={{
                  backgroundColor: tenant.secondaryColor
                }} data-id="element-798"></div>
                    <input type="text" defaultValue={tenant.secondaryColor} className="flex-1 px-3 py-2 bg-slate-50 border border-slate-200 rounded-lg text-sm font-mono focus:border-emerald-500 focus:ring-1 focus:ring-emerald-500 outline-none" data-id="element-799" />
                  </div>
                </div>
              </div>

              {/* Preview */}
              <div data-id="element-800">
                <label className="block text-sm font-medium text-slate-700 mb-3" data-id="element-801">
                  Vorschau
                </label>
                <div className="border border-slate-200 rounded-xl overflow-hidden" data-id="element-802">
                  <div className="h-3" style={{
                backgroundColor: tenant.primaryColor
              }} data-id="element-803"></div>
                  <div className="p-4 flex items-center gap-3 bg-slate-50" data-id="element-804">
                    <div className="w-8 h-8 rounded-full flex items-center justify-center text-lg" style={{
                  backgroundColor: tenant.primaryColor
                }} data-id="element-805">
                      {tenant.logo}
                    </div>
                    <span className="font-bold text-slate-900 text-sm" data-id="element-806">
                      {tenant.name}
                    </span>
                    <span className="text-xs text-slate-500 ml-auto" data-id="element-807">
                      {tenant.league}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex justify-end" data-id="element-808">
              <button className="flex items-center gap-2 px-5 py-2.5 bg-emerald-500 text-white rounded-lg text-sm font-medium hover:bg-emerald-600 transition-colors shadow-sm" data-id="element-809">
                <SaveIcon size={16} data-id="element-810" />
                Änderungen speichern
              </button>
            </div>
          </>}

        {activeSection === 'general' && <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-6" data-id="element-811">
            <h2 className="text-lg font-bold text-slate-900 mb-1" data-id="element-812">
              Allgemeine Einstellungen
            </h2>
            <p className="text-sm text-slate-500 mb-6" data-id="element-813">
              Grundlegende Informationen zu Ihrem Netzwerk.
            </p>
            <div className="space-y-5" data-id="element-814">
              <div data-id="element-815">
                <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-816">
                  Club Name
                </label>
                <input type="text" defaultValue={tenant.name} className="w-full px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-lg text-sm focus:border-emerald-500 focus:ring-1 focus:ring-emerald-500 outline-none" data-id="element-817" />
              </div>
              <div data-id="element-818">
                <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-819">
                  Liga / Verband
                </label>
                <input type="text" defaultValue={tenant.league} className="w-full px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-lg text-sm focus:border-emerald-500 focus:ring-1 focus:ring-emerald-500 outline-none" data-id="element-820" />
              </div>
              <div data-id="element-821">
                <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-822">
                  Sportart
                </label>
                <input type="text" defaultValue={tenant.sport} className="w-full px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-lg text-sm focus:border-emerald-500 focus:ring-1 focus:ring-emerald-500 outline-none" data-id="element-823" />
              </div>
              <div data-id="element-824">
                <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-825">
                  Netzwerk-URL
                </label>
                <div className="flex items-center" data-id="element-826">
                  <span className="px-3 py-2.5 bg-slate-100 border border-r-0 border-slate-200 rounded-l-lg text-sm text-slate-500" data-id="element-827">
                    connectra.io/
                  </span>
                  <input type="text" defaultValue={tenant.slug} className="flex-1 px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-r-lg text-sm focus:border-emerald-500 focus:ring-1 focus:ring-emerald-500 outline-none" data-id="element-828" />
                </div>
              </div>
            </div>
            <div className="flex justify-end mt-6" data-id="element-829">
              <button className="flex items-center gap-2 px-5 py-2.5 bg-emerald-500 text-white rounded-lg text-sm font-medium hover:bg-emerald-600 transition-colors shadow-sm" data-id="element-830">
                <SaveIcon size={16} data-id="element-831" />
                Speichern
              </button>
            </div>
          </div>}

        {activeSection === 'members' && <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-6" data-id="element-832">
            <h2 className="text-lg font-bold text-slate-900 mb-1" data-id="element-833">
              Mitglieder-Einstellungen
            </h2>
            <p className="text-sm text-slate-500 mb-6" data-id="element-834">
              Verwalten Sie Zugriffsrechte und Einladungen.
            </p>
            <div className="space-y-6" data-id="element-835">
              <div className="flex items-center justify-between p-4 bg-slate-50 rounded-lg border border-slate-100" data-id="element-836">
                <div data-id="element-837">
                  <h4 className="text-sm font-bold text-slate-900" data-id="element-838">
                    Neue Kontakte pro Woche
                  </h4>
                  <p className="text-xs text-slate-500 mt-0.5" data-id="element-839">
                    Maximale Anzahl neuer Kontaktanfragen pro Mitglied.
                  </p>
                </div>
                <select className="px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:border-emerald-500 outline-none" data-id="element-840">
                  <option data-id="element-841">10 pro Woche</option>
                  <option data-id="element-842">20 pro Woche</option>
                  <option data-id="element-843">50 pro Woche</option>
                  <option data-id="element-844">Unbegrenzt</option>
                </select>
              </div>
              <div className="flex items-center justify-between p-4 bg-slate-50 rounded-lg border border-slate-100" data-id="element-845">
                <div data-id="element-846">
                  <h4 className="text-sm font-bold text-slate-900" data-id="element-847">
                    Profilsichtbarkeit bei Events
                  </h4>
                  <p className="text-xs text-slate-500 mt-0.5" data-id="element-848">
                    Standard-Einstellung für neue Mitglieder.
                  </p>
                </div>
                <select className="px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:border-emerald-500 outline-none" data-id="element-849">
                  <option data-id="element-850">Opt-in (Standard aus)</option>
                  <option data-id="element-851">Opt-out (Standard an)</option>
                </select>
              </div>
              <div className="flex items-center justify-between p-4 bg-slate-50 rounded-lg border border-slate-100" data-id="element-852">
                <div data-id="element-853">
                  <h4 className="text-sm font-bold text-slate-900" data-id="element-854">
                    Event-Teilnehmer zu Netzwerk-Mitgliedern
                  </h4>
                  <p className="text-xs text-slate-500 mt-0.5" data-id="element-855">
                    Automatische Einladung nach Event-Teilnahme.
                  </p>
                </div>
                <div className="relative" data-id="element-856">
                  <input type="checkbox" defaultChecked className="sr-only peer" id="autoConvert" data-id="element-857" />
                  <label htmlFor="autoConvert" className="block w-11 h-6 bg-slate-300 rounded-full cursor-pointer peer-checked:bg-emerald-500 transition-colors after:content-[''] after:absolute after:top-0.5 after:left-0.5 after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:after:translate-x-5" data-id="element-858"></label>
                </div>
              </div>
            </div>
          </div>}

        {activeSection === 'notifications' && <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-6" data-id="element-859">
            <h2 className="text-lg font-bold text-slate-900 mb-1" data-id="element-860">
              Benachrichtigungen
            </h2>
            <p className="text-sm text-slate-500 mb-6" data-id="element-861">
              Konfigurieren Sie, welche Benachrichtigungen gesendet werden.
            </p>
            <div className="space-y-4" data-id="element-862">
              {[{
            label: 'Neue Nachrichten',
            desc: 'Bei eingehenden Direktnachrichten.',
            checked: true
          }, {
            label: 'Event-Erinnerungen',
            desc: '24h und 1h vor Event-Beginn.',
            checked: true
          }, {
            label: 'Neue Kontaktanfragen',
            desc: 'Wenn jemand sich vernetzen möchte.',
            checked: true
          }, {
            label: 'Feed-Aktivität',
            desc: 'Likes und Kommentare auf eigene Beiträge.',
            checked: false
          }, {
            label: 'Neue Mitglieder',
            desc: 'Wenn neue Unternehmen dem Netzwerk beitreten.',
            checked: true
          }, {
            label: 'Challenge-Updates',
            desc: 'Fortschritte und neue Challenges.',
            checked: false
          }].map((item, i) => <div key={i} className="flex items-center justify-between p-4 bg-slate-50 rounded-lg border border-slate-100" data-id="element-863">
                  <div data-id="element-864">
                    <h4 className="text-sm font-bold text-slate-900" data-id="element-865">
                      {item.label}
                    </h4>
                    <p className="text-xs text-slate-500 mt-0.5" data-id="element-866">{item.desc}</p>
                  </div>
                  <div className="relative" data-id="element-867">
                    <input type="checkbox" defaultChecked={item.checked} className="sr-only peer" id={`notif-${i}`} data-id="element-868" />
                    <label htmlFor={`notif-${i}`} className="block w-11 h-6 bg-slate-300 rounded-full cursor-pointer peer-checked:bg-emerald-500 transition-colors after:content-[''] after:absolute after:top-0.5 after:left-0.5 after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:after:translate-x-5" data-id="element-869"></label>
                  </div>
                </div>)}
            </div>
          </div>}

        {activeSection === 'security' && <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-6" data-id="element-870">
            <h2 className="text-lg font-bold text-slate-900 mb-1" data-id="element-871">
              Sicherheit & Datenschutz
            </h2>
            <p className="text-sm text-slate-500 mb-6" data-id="element-872">
              Schützen Sie Ihr Netzwerk und die Daten Ihrer Mitglieder.
            </p>
            <div className="space-y-4" data-id="element-873">
              <div className="flex items-center justify-between p-4 bg-slate-50 rounded-lg border border-slate-100" data-id="element-874">
                <div data-id="element-875">
                  <h4 className="text-sm font-bold text-slate-900" data-id="element-876">
                    E-Mail-Adressen verbergen
                  </h4>
                  <p className="text-xs text-slate-500 mt-0.5" data-id="element-877">
                    E-Mail-Adressen werden nicht in Profilen angezeigt.
                  </p>
                </div>
                <div className="relative" data-id="element-878">
                  <input type="checkbox" defaultChecked className="sr-only peer" id="hideEmail" data-id="element-879" />
                  <label htmlFor="hideEmail" className="block w-11 h-6 bg-slate-300 rounded-full cursor-pointer peer-checked:bg-emerald-500 transition-colors after:content-[''] after:absolute after:top-0.5 after:left-0.5 after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:after:translate-x-5" data-id="element-880"></label>
                </div>
              </div>
              <div className="flex items-center justify-between p-4 bg-slate-50 rounded-lg border border-slate-100" data-id="element-881">
                <div data-id="element-882">
                  <h4 className="text-sm font-bold text-slate-900" data-id="element-883">
                    Spam-Schutz
                  </h4>
                  <p className="text-xs text-slate-500 mt-0.5" data-id="element-884">
                    Begrenzung neuer Kontakte und Nachrichten pro Woche.
                  </p>
                </div>
                <div className="relative" data-id="element-885">
                  <input type="checkbox" defaultChecked className="sr-only peer" id="spamProtect" data-id="element-886" />
                  <label htmlFor="spamProtect" className="block w-11 h-6 bg-slate-300 rounded-full cursor-pointer peer-checked:bg-emerald-500 transition-colors after:content-[''] after:absolute after:top-0.5 after:left-0.5 after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:after:translate-x-5" data-id="element-887"></label>
                </div>
              </div>
              <div className="flex items-center justify-between p-4 bg-slate-50 rounded-lg border border-slate-100" data-id="element-888">
                <div data-id="element-889">
                  <h4 className="text-sm font-bold text-slate-900" data-id="element-890">
                    Zwei-Faktor-Authentifizierung
                  </h4>
                  <p className="text-xs text-slate-500 mt-0.5" data-id="element-891">
                    Zusätzliche Sicherheit für Admin-Konten.
                  </p>
                </div>
                <span className="px-3 py-1 bg-emerald-100 text-emerald-700 text-xs font-bold rounded-full" data-id="element-892">
                  Aktiv
                </span>
              </div>
            </div>
          </div>}
      </div>
    </div>;
}